import SsgFallback from '@components/SsgFallback'
import getReservationsStorePublicOptions from '@data/queries/reservations/getReservationsStorePublicOptions.reservations'
import getWebsiteInitialData from '@data/queries/website/websiteInitialData.main'
import getWebsitePagesInfo from '@data/queries/website/websitePagesInfo.main'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import getWebsiteIdFromHostname from '@helpers/websites/getWebsiteIdFromHostname'
import AbstractLayout from '@page-components/Layout/AbstractLayout'
import Clean from '@page-components/Layout/Clean'
import Website from '@page-components/Layout/Website'
import NotFound from '@page-components/NotFound'
import NoWebsite from '@page-components/NoWebsite'
import CreateReservationFromStore from '@page-components/Reservations/CreateReservationFromStore'
import {InferGetStaticPropsType} from 'next'
import {useRouter} from 'next/router'

export default function ReservasStore(props: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  if (router.isFallback) {
    return <SsgFallback />
  }

  if (!props.website) {
    return <NoWebsite />
  }

  if (!props.storeOptions) {
    return (
      <AbstractLayout LayoutComponent={Website} >
        <NotFound />
      </AbstractLayout>
    )
  }

  return (
    <AbstractLayout LayoutComponent={Clean} darkTheme="darkv2">
      <CreateReservationFromStore storeOptions={props.storeOptions} />
    </AbstractLayout>
  )
}

export const getStaticProps = async context => {
  const {websiteId} = await getWebsiteIdFromHostname(context.params.hostname)
  const initialData = await getWebsiteInitialData(websiteId)
  const {website} = await getWebsitePagesInfo(websiteId)
  const storeOptions = await getReservationsStorePublicOptions(context.params.reservationStoreId)
  const translationProps = await websiteSSRTranslations(context.params.hostname, [
    'website',
    'generic',
    'checkoutv3',
    'auth',
    'terms',
    'deprecated'
  ])

  return {
    props: {
      ...translationProps,
      initialData,
      websiteId,
      website,
      storeOptions,
      lastRevalidatedAt: new Date().toISOString()
    },
    revalidate: 60 * 60 * 1
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
